import { useContext, useEffect } from "preact/hooks"
import { defaultSize, skeletonLoading } from "@/config"
import { useActions, useNostoAppState } from "@nosto/search-js/preact/hooks"
import { getQueryFromUrlState } from "@/mapping/url/getCurrentUrlState"
import { updateUrlFromQuery } from "@/mapping/url/updateUrl"
import { StoreContext, useConfig } from "@nosto/search-js/preact/common"
import { createSkeletonContent } from "./skeletonContent"
import { usePopState } from "@/hooks/usePopState"

export default function SearchQueryHandler() {
  const store = useContext(StoreContext)
  const { newSearch } = useActions()

  // Get current query, pagination, filter, and sort state from app
  const { initialized, query, from, filter, size, sort } = useNostoAppState(state => ({
    initialized: state.initialized,
    query: state.query?.query,
    from: state.query?.products?.from,
    filter: state.query?.products?.filter,
    size: state.query?.products?.size ?? defaultSize,
    sort: state.query?.products?.sort
  }))

  const { pageType } = useConfig()

  // Initialize search from URL on first load
  useEffect(() => {
    const query = getQueryFromUrlState()
    const isResultsPage = (pageType === "search" && query.query) || pageType === "category"
    if (isResultsPage) {
      if (skeletonLoading) {
        // init store with skeleton content to avoid layout shift
        store.updateState(createSkeletonContent(query))
      }
      // execute initial query
      newSearch(query)
    }
  }, [store, newSearch, pageType])

  // Update URL when app state changes
  useEffect(() => {
    if (initialized) {
      updateUrlFromQuery({ from, size, query, filter, sort })
    }
  }, [initialized, query, from, size, filter, sort])

  // Handle browser back/forward navigation
  usePopState(() => {
    const query = getQueryFromUrlState()
    // execute search with new URL state
    newSearch(query)
  }, [newSearch])

  return null
}
